import { useMutation } from '@tanstack/react-query';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

import { ButtonRow } from '../../../components/global/ButtonRow/ButtonRow.tsx';
import { FlowStepWithContainer } from '../../../components/layout/FlowStepWithContainer.tsx';
import { EmailForm } from '../../../forms/Email/EmailForm.tsx';
import { resetPassword } from '../../../services/promoterAuthentication.ts';

export const Email: FC = () => {
  const navigate = useNavigate();

  const { mutate: enterEmail, isPending } = useMutation({
    mutationFn: async ({ email }: { email: string }) => {
      await resetPassword.reset({
        email,
      });

      return email;
    },
    onSuccess: (email) => {
      void navigate('../code-verification', { relative: 'path', state: { email } });
    },
  });

  return (
    <FlowStepWithContainer
      bodyContent={
        <EmailForm
          buttonSlot={
            <ButtonRow
              primaryButton={{
                type: 'submit',
                text: 'Next',
                isPending,
              }}
            />
          }
          defaultValues={{ email: '' }}
          onSubmit={(data) => enterEmail(data)}
        />
      }
      heading="Enter you email"
      progress={{ currentStep: 1, totalSteps: 3 }}
    />
  );
};
